import { ClientRecord } from "../../ClientsGrid.utils";

export interface ApprovalStatusRendererProps {
  rowData: ClientRecord;
}

export interface ApproverData {
  UserName: string;
  UserFullName: string;
  UserRole: string;
  ApprovalStatus: string;
  Message: string;
  UpdatedDate: string;
  COIApprover?: "Y" | "N" | null;
}

export const COI_REGISTRY_REVIEWERS_LABEL = "COI Registry Reviewers";

/**
 * Calculates the popup position relative to the trigger button.
 *
 * @param buttonRef - Ref to the button element triggering the popup.
 * @param setPopupPosition - Callback to set the position of the popup on screen.
 */
export const updatePopupPosition = (
  buttonRef: { current: { getBoundingClientRect: () => any } | null },
  setPopupPosition: (arg: { top: number; left: number }) => void
) => {
  if (buttonRef.current) {
    const rect = buttonRef.current.getBoundingClientRect();
    setPopupPosition({
      top: rect.bottom + window.scrollY - 5,
      left: rect.left + window.scrollX - 575,
    });
  }
};

/**
 * Collapses every COIApprover='Y' row into a single "COI Registry Reviewers"
 * row, since they always share one status (bulk-resolved together the
 * moment any one of them decides) -- individual identity is captured on the
 * conflict match record itself, not needed on this approver-status popup.
 *
 * @param approvers - Raw approver rows for this client/EL.
 */
export const groupCOIApprovers = (approvers: ApproverData[]): ApproverData[] => {
  const coiRows = approvers.filter((approver) => approver.COIApprover === "Y");
  const regularRows = approvers.filter((approver) => approver.COIApprover !== "Y");

  if (coiRows.length === 0) {
    return regularRows;
  }

  const [representativeRow] = coiRows;
  return [
    {
      ...representativeRow,
      UserFullName: COI_REGISTRY_REVIEWERS_LABEL,
      UserRole: "",
    },
    ...regularRows,
  ];
};
